import { render, staticRenderFns } from "./studentsExam.vue?vue&type=template&id=b93aa086&scoped=true&"
import script from "./studentsExam.vue?vue&type=script&lang=js&"
export * from "./studentsExam.vue?vue&type=script&lang=js&"
import style0 from "./studentsExam.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./studentsExam.vue?vue&type=style&index=1&id=b93aa086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93aa086",
  null
  
)

export default component.exports